<div class="container-fluid" style="max-height: 100%;">
  <div class="row" style="justify-content: space-between; max-width: 100%">
    <h3 style="margin: 10px">Conversations</h3>
    <div class="row">
      <kendo-textbox style="width: 200px; height: 40px; margin: 10px" [(value)]="search"></kendo-textbox>
      <button kendoButton [themeColor]="'primary'" style="height: 40px; margin: 10px" [svgIcon]="searchIcon" (click)="loadMessages()"></button>
    </div>
  </div>
  <kendo-grid
    [data]="gridView"
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [sort]="gridState.sort"
    [pageable]="true"
    [sortable]="true"
    (dataStateChange)="dataStateChange($event)"
    (detailExpand)="expandRow($event)"
    (detailCollapse)="collapseRow($event)"
    style="max-height: 80vh"
  >
    <kendo-grid-column field="text" title="Question"></kendo-grid-column>
    <kendo-grid-column field="tokens" title="User Tokens" [width]="136"></kendo-grid-column>
    <kendo-grid-column field="answer.tokens" title="Agent Tokens" [width]="136"></kendo-grid-column>
    <kendo-grid-column title="Tot. tokens" [width]="120">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.tokens + dataItem.answer.tokens }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="city" title="City" [width]="90"></kendo-grid-column>
    <kendo-grid-column field="country" title="Country" [width]="110"></kendo-grid-column>
    <kendo-grid-column field="timestamp" title="Timestamp" [width]="200">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.timestamp | date:'dd-MM-yyyy HH:mm:ss' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Feedback" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        @if(dataItem.answer?.feedback?.type === 'negative') {
          <button kendoButton [svgIcon]="thumbDownIcon" fillMode="clear" [themeColor]="'error'"></button>
        } @else {
          <button kendoButton [svgIcon]="thumbDownOutlineIcon" fillMode="clear" (click)="giveFeedback(dataItem, 'negative')"></button>
        }
        @if(dataItem.answer?.feedback?.type === 'positive') {
          <button kendoButton [svgIcon]="thumbUpIcon" fillMode="clear" [themeColor]="'success'"></button>
        } @else {
          <button kendoButton [svgIcon]="thumbUpOutlineIcon" fillMode="clear" (click)="giveFeedback(dataItem, 'positive')"></button>
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Actions" [width]="220">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-buttongroup style="z-index: 0">
          <button kendoButton [themeColor]="'primary'" (click)="showInChat(dataItem)">Show in Chat</button>
          <button kendoButton [themeColor]="'error'" (click)="deleteMessage(dataItem.messageId)">Delete</button>
        </kendo-buttongroup>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem>
      <div>
        <h4>Agent Response</h4>
        <div style="border: 1px dotted grey; border-radius: 4px; padding: 0 14px">
          <markdown [data]="dataItem.answer?.text"></markdown>
          @if (dataItem.answer?.markdownSources?.length > 0) {
            <h4>Source</h4>
            <ul>
              @for (source of dataItem.answer?.markdownSources; track source.itemName) {
                <li>{{ source.itemName }} (v{{ source.version }})</li>
              }
            </ul>
          }
        </div>
        <h4>Improve Response</h4>
        <kendo-textarea
          [ngModel]="improvementText[dataItem.answer.messageId] ?? ''"
          (ngModelChange)="improvementText[dataItem.answer.messageId] = $event">
        </kendo-textarea>
        <div class="k-flex-layout k-justify-content-between k-mx-sm">
          @if (dataItem.answer?.feedback?.updatedAt) {
            <small><strong>Updated At:</strong> {{ dataItem.answer.feedback.updatedAt | date:'short' }}</small>
          }
          @if (dataItem.answer?.feedback?.createdAt) {
            <small><strong>Created At:</strong> {{ dataItem.answer.feedback.createdAt | date:'short' }}</small>
          }
        </div>
        <hr>
        <kendo-label text="Updated by">
          <kendo-textbox
            [ngModel]="updatedBy[dataItem.answer.messageId] ?? ''"
            (ngModelChange)="updatedBy[dataItem.answer.messageId] = $event"
            placeholder="Updated by">
          </kendo-textbox>
        </kendo-label>
        <div class="k-mt-lg"></div>
        <button kendoButton [themeColor]="'primary'" (click)="saveImprovement(dataItem)">Save</button>
      </div>
    </ng-template>
  </kendo-grid>
</div>


<div class="chat-container" [ngClass]="chatState">
  <div class="chat-header">
    <h5>Conversation</h5>
    <div>
      <button kendoButton [svgIcon]="minimizeIcon" (click)="reduceChat()" *ngIf="chatState === 'open'"></button>
      <button kendoButton [svgIcon]="maximizeIcon" (click)="expandChat()" *ngIf="chatState === 'reduced'">
      </button>
      <button kendoButton [svgIcon]="closeIcon" (click)="closeChat()">
      </button>
    </div>
  </div>
  <div class="chat-body">
    <kendo-chat [messages]="chatMessages" [user]="user">
      <ng-template kendoChatMessageTemplate let-message>
        <markdown [data]="message.text"></markdown>
      </ng-template>
    </kendo-chat>
  </div>
</div>
